import React from "react";
import "../styles/HomePage.css";
import AuthService from "../AuthService";
// @ts-ignore
import image from "../assets/homepage_main.jpeg"

const HomePage: React.FC = () => {
    return (
        <>
            <AuthService />
            <div className="flex-container">
                <p className="about-paragraph">A database devoted to the study of Buddhist texts and literary corpora in Sanskrit and Tibetan with particular emphasis on evolution of scriptures, formation of canons, and intellectual networks</p>
                <div className="image-container">
                    <img src={image} className="image-homepage" alt="Buddha" />
                </div>
            </div>
        </>
    );
};

export default HomePage;
